export const INITIAL_VALUE = 'INITIAL_VALUE';
export const ADD_NEW_MEMO = 'ADD_NEW_MEMO';
export const SET_LANGUAGE = 'SET_LANGUAGE';
